module.exports = __webpack_public_path__ + "media/images/redesign-images/sorority/image-grid/grid-11-1ac193332d29cba8af1aa2dcd39e09aa.jpg";